const branding = (window.__RUNTIME_CONFIG__ || {}).BRANDING || {};
const cached = JSON.parse(localStorage.getItem("branding") || "null");
const source = cached || branding;

const brandConfig = {
  appName: source.appName || "arthaTRACK",
  logoPath: source.logoPath || "/logos/logo.png",
  footerText: source.footerText || "Arthavedh",
  primaryColor: source.primaryColor || "#0f2043",
  accentColor: source.accentColor || "#fd5f07",
};

/** Returns the current org slug from URL path (/acme), query param (?org=acme), or localStorage fallback */
const KNOWN_ROUTES = ['home', 'registration', 'getOtp', 'digitalKYC'];
export function getOrgSlug() {
  const firstSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
  return new URLSearchParams(window.location.search).get('org')
    || (firstSegment && !KNOWN_ROUTES.includes(firstSegment) ? firstSegment : null)
    || localStorage.getItem('orgSlug')
    || null;
}

/** Live-update branding across the app without page reload */
export function applyBranding(newConfig) {
  Object.assign(brandConfig, newConfig);

  // Update CSS variables
  document.documentElement.style.setProperty("--brand-primary", newConfig.primaryColor || brandConfig.primaryColor);
  document.documentElement.style.setProperty("--brand-accent", newConfig.accentColor || brandConfig.accentColor);

  // Update page title
  if (newConfig.appName) document.title = newConfig.appName;

  // Cache to localStorage for pre-auth pages (login)
  localStorage.setItem("branding", JSON.stringify(brandConfig));

  // Update runtime config in memory
  if (window.__RUNTIME_CONFIG__) {
    window.__RUNTIME_CONFIG__.BRANDING = { ...brandConfig };
  }
}

export default brandConfig;
